var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"hero-body soupe-ui-accordion-item-content",style:({ height: _vm.height })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }